import { storableError } from '../../util/errors';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { getRewildingInfoFilesFromListing } from '../../util/api';

// ================ Action types ================ //

export const FETCH_INFORMATION_REQUEST = 'app/RewildingDocsPage/FETCH_INFORMATION_REQUEST';
export const FETCH_INFORMATION_SUCCESS = 'app/RewildingDocsPage/FETCH_INFORMATION_SUCCESS';
export const FETCH_INFORMATION_ERROR = 'app/RewildingDocsPage/FETCH_INFORMATION_ERROR';

export const SET_USER_ID = 'app/RewildingDocsPage/SET_USER_ID';

// ================ Reducer ================ //

const initialState = {
  queryInProgress: false,
  queryInformationError: null,
  userId: null,
  files: [],
  listingInfo: {
    id: null,
    title: null,
  },
};

const rewildingDocsPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_INFORMATION_REQUEST:
      return {
        ...state,
        queryInProgress: true,
        queryInformationError: null,
      };
    case FETCH_INFORMATION_SUCCESS:
      return {
        ...state,
        ...payload,
        queryInProgress: false,
      };
    case FETCH_INFORMATION_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, queryInProgress: false, queryInformationError: payload };
    case SET_USER_ID:
      return {
        ...state,
        userId: payload,
      };
    default:
      return state;
  }
};

export default rewildingDocsPageReducer;

// ================ Action creators ================ //

export const queryInformationRequest = () => ({
  type: FETCH_INFORMATION_REQUEST,
});

export const queryInformationSuccess = payload => ({
  type: FETCH_INFORMATION_SUCCESS,
  payload,
});

export const queryInformationError = e => ({
  type: FETCH_INFORMATION_ERROR,
  error: true,
  payload: e,
});

export const setUserId = payload => ({
  type: SET_USER_ID,
  payload,
});

export const queryInformationByTransactionId = ({ transactionId }) => async (
  dispatch,
  getState,
  sdk
) => {
  dispatch(queryInformationRequest());

  try {
    const transactionResponse = await sdk.transactions.show({
      id: transactionId,
      include: ['customer', 'listing'],
    });

    const user = transactionResponse.data.included.find(item => item.type === 'user');

    if (user) {
      dispatch(setUserId(user.id.uuid));
    }

    const listing = transactionResponse.data.included.find(item => item.type === 'listing');

    const listingInfo = {};
    const files = [];
    if (listing) {
      const listingId = listing.id.uuid;
      listingInfo.id = listingId;
      listingInfo.title = listing.attributes.title;
    
      const { rewildingInfoFiles = [] } = await getRewildingInfoFilesFromListing({
        listingId,
      });
      files.push(...rewildingInfoFiles);
    }

    dispatch(queryInformationSuccess({ listingInfo, files }));
  } catch (e) {
    dispatch(queryInformationError(storableError(e)));
    throw e;
  }
};

// ================ Thunks ================ //

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const { transactionId } = params || {};

  return Promise.all([
    dispatch(fetchCurrentUser()),
    dispatch(queryInformationByTransactionId({ transactionId })),
  ]).catch(e => {
    throw e;
  });
};
